import React, { Component } from 'react';
import { CoinsService } from '../../services/coins';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './big-header.css';

import {
  CoinsBox
} from '../../components';

export default class BigHeader extends Component {
  constructor(props) {
    super(props);

    this.openHome = this.openHome.bind(this);

    this.state = {
      "render_social": false,
      "render_coins_box": false,
      "card_height": 0
    }

    this.cardRef = React.createRef();
  }

  componentDidMount() {
    var width = this.cardRef.current.offsetWidth;
    var calc = width / 428 * 1;
    this.setState({
      "card_height": 290 * calc
    })
  }
  
  componentWillMount() {
    AOS.init();
  }

  openHome() {
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  shareClick() {
    this.setState({
      "render_social": true
    })
  }

  closeShareClick() {
    var _this = this;
    var items = document.getElementsByClassName("rdp-react-template-component-big-header-social-item");
    for (let i = 0; i < items.length; i++) {
      items[i].style.transform = "translate3d(100px,0,0)";
      items[i].style.opacity = "0";
    }

    setTimeout(function() {
      _this.setState({
        "render_social": false
      })
    }, 800)
  }

  onXClick() {
    var exist = CoinsService.exist("linkedin_share", "event");

    if (!exist) {
      CoinsService.add({
        "type": "linkedin_share",
        "target": "event",
        "coins": 1000
      })
      this.setState({
        "render_coins_box": true
      });  
    }

    window.open("https://www.twitter.com/intent/tweet?url=https://pocs.digitalpages.com.br/bancobv", "_blank");
  }

  onFacebookClick() {
    var exist = CoinsService.exist("facebook_share", "event");

    if (!exist) {
      CoinsService.add({
        "type": "facebook_share",
        "target": "event",
        "coins": 1000
      })
      this.setState({
        "render_coins_box": true
      });
    }

    window.open("https://www.facebook.com/sharer/sharer.php?u=https://pocs.digitalpages.com.br/bancobv", "_blank");
  }

  onLinkedinClick() {
    var exist = CoinsService.exist("linkedin_share", "event");

    if (!exist) {
      CoinsService.add({
        "type": "linkedin_share",
        "target": "event",
        "coins": 1000
      })
      this.setState({
        "render_coins_box": true
      });
    }

    window.open("https://www.linkedin.com/sharing/share-offsite/?url=https://pocs.digitalpages.com.br/bancobv", "_blank");
  }

  onCloseCoinsBox() {
    this.setState({
      "render_coins_box": false
    })
  }

  render() {
    return (
      <div ref={this.cardRef} className="rdp-react-template-component-big-header" style={{
        backgroundImage: `url(${this.props.cover})`,
        height: `${this.state.card_height}px`
      }}>
        {this.state.render_coins_box &&
          <CoinsBox
            title="Parabéns!"
            message="Você ganhou <b>1.000<br/><span style='color:#56c8e2;'>BV Coins</span>!</b>"
            onClose={() => this.onCloseCoinsBox()}
            buttonLabel="Voltar para o Evento"
          />
        }
        <div className="rdp-react-template-component-big-header-overlay">
          <span className="rdp-react-template-component-big-header-back" data-aos="fade-up" data-aos-duration="500" onClick={() => this.props.onClick()}></span>
          {/* <h3 className="rdp-react-template-component-big-header-title" data-aos="fade-up" data-aos-duration="500" data-aos-delay="150">{this.props.title}</h3> */}
          {/* <h3 className="rdp-react-template-component-big-header-subtitle" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" dangerouslySetInnerHTML={{__html: this.props.subtitle}}></h3> */}
        </div>
        {this.state.render_social &&
          <>
            <div className="rdp-react-template-component-big-header-social-overlay" onClick={() => this.closeShareClick()}></div>
            <ul className="rdp-react-template-component-big-header-social">
            {/* <li className="rdp-react-template-component-big-header-social-item instagram" data-aos="fade-left" data-aos-duration="500" data-aos-delay="300"></li> */}
              <li className="rdp-react-template-component-big-header-social-item x" onClick={() => this.onXClick()} data-aos="fade-left" data-aos-duration="500" data-aos-delay="200"></li>
              <li className="rdp-react-template-component-big-header-social-item facebook" onClick={() => this.onFacebookClick()} data-aos="fade-left" data-aos-duration="500" data-aos-delay="100"></li>
              <li className="rdp-react-template-component-big-header-social-item linkedin" onClick={() => this.onLinkedinClick()} data-aos="fade-left" data-aos-duration="500"></li>
            </ul>
          </>
        }
        <span className="rdp-react-template-component-big-header-share-btn" data-aos="fade-left" data-aos-duration="800" onClick={() => this.shareClick()}></span>
      </div>
    );
  }
}
